define( [
	"../../core"
], function( jQuery ) {
	"use strict";

	return jQuery.now();
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/ajax/var/nonce.js
// module id = 115
// module chunks = 96